// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1gdCI","alertIcon":"ConfirmModal_alertIcon__3I2A6"};